module.exports = __webpack_public_path__ + "static/media/Deer.e34a1c61.webm";